import axios from 'axios';
import reportErrorToSentry from '~/utils/reportErrorToSentry';
import { API_TIMEOUT } from './common/constants';
import TimeoutError from './common/ApiTimeoutError';

export default {
  config: {
    timeout: API_TIMEOUT,
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  },

  trovitFetch(url, method, body, config) {
    const requestConfig = { ...this.config, ...config };
    const Error = this.ApiServiceError;

    return axios(url, { method, data: JSON.stringify(body), ...requestConfig })
      .then(response => response.data)
      .catch(error => {
        if (error.code === 'ECONNABORTED') {
          const { apiName, apiResource } = body;

          throw new TimeoutError(
            `${error.message} - when calling to the endpoint: ${apiResource} of the api ${apiName}`
          );
        }

        if (error.response) {
          const { reason, errors } = error.response.data;
          const { status } = error.response;

          const specificError = Array.isArray(errors) ? errors[0] : errors;
          const errorMessage = reason ? `${reason} - ${specificError.error}` : specificError.detail;
          const errorException = new Error(status, errorMessage, status);

          reportErrorToSentry(errorException);
          throw errorException;
        }
      });
  },
};



// WEBPACK FOOTER //
// ./app/sdk/api.js